/** Normalize API / user date strings to yyyy-MM-dd for signup APIs. */
export function toYyyyMmDd(iso?: string | null): string {
  if (!iso) return "";
  const s = String(iso).trim();
  if (!s) return "";

  const isoPrefix = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoPrefix) return `${isoPrefix[1]}-${isoPrefix[2]}-${isoPrefix[3]}`;

  const dmy = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (dmy) {
    return `${dmy[3]}-${dmy[2].padStart(2, "0")}-${dmy[1].padStart(2, "0")}`;
  }

  const partial = s.match(/^(\d{4})(?:-(\d{2}))?(?:-(\d{2}))?$/);
  if (!partial) return "";
  return `${partial[1]}-${partial[2] || "01"}-${partial[3] || "01"}`;
}

/** Rough Hijri yyyy-MM → Gregorian yyyy-MM-dd (fallback when API omits gregorian). */
export function hijriYearMonthToApproxGregorian(hijriYm?: string | null): string {
  const m = String(hijriYm || "").trim().match(/^(\d{4})-(\d{2})/);
  if (!m) return "";
  const gregYear = parseInt(m[1], 10) - 579;
  if (!Number.isFinite(gregYear) || gregYear < 1900 || gregYear > 2100) return "";
  return `${gregYear}-${m[2]}-01`;
}

export type YaqeenDobInput = {
  dateOfBirthSent: string;
  isCitizen: boolean;
  gregDateInput?: string;
};

export type YaqeenDobVerified = {
  dobGregorian?: string | null;
  dobHijri?: string | null;
};

/** Pick best gregorian + hijri DOB after Yaqeen verify. */
export function resolveDobFromYaqeen(
  verified: YaqeenDobVerified,
  input: YaqeenDobInput
): { dob: string; dobHijri: string } {
  let dob = toYyyyMmDd(verified.dobGregorian);
  const hijriRaw =
    (verified.dobHijri ?? "").trim() ||
    (input.isCitizen ? input.dateOfBirthSent.trim() : "");

  if (!dob && !input.isCitizen) {
    dob = toYyyyMmDd(input.gregDateInput) || toYyyyMmDd(input.dateOfBirthSent);
  }

  if (!dob && hijriRaw) {
    dob = hijriYearMonthToApproxGregorian(hijriRaw);
  }

  return { dob, dobHijri: hijriRaw };
}
